module.exports = __webpack_public_path__ + "img/sign-active.a084dd4b.png";